module.exports = __webpack_public_path__ + "img/sankaku_82_red.6fee73b8.png";